module.exports = __webpack_public_path__ + "static/img/results_02.958d37b1.svg";